import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";

export const StyledModal = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    borderRadius: "12px",
    boxShadow: "0px 2px 48px rgba(0, 0, 0, 0.2)",
  },
}));
